import { gql } from '@apollo/client'

export default gql(`
    mutation updateProductionStudio($id: ID!, $name: String!, $project: String ) {
        updateProductionStudio(
            input: {
                name: $name
            },
            id: $id,
            project: $project
        ) {
            id
            name
            assetCount
        }
    }`
)
